<div class="app-view-container h-full">
  <div class="main-actions">
    <div class="actions-container">
      <div *ngIf="navLinks.length > 1" class="tabs-container w-full">
        <sp-navigation-link [navLinks]="navLinks" (selectedTab)="currentTabClick($event)"></sp-navigation-link>
      </div>
    </div>

    <div *ngIf="currentTab.includes('assets')" class="actions-container">
      <thehubz-asset-view-actions
        [filterCollectionFormData]="filterCollectionFormData"
        [selectedFilterObject]="selectedFilterObject"
        [filteredList]="filteredList"
        [assetCount]="assetCount"
        [currentTab]="currentTab"
        [appliedFilters]="appliedFilters"
        [selectedViewType]="selectedViewType"
        [selectedViewSection2]="selectedViewSection2"
        [collectionInfo]="collectionInfo"
        [collectionPublished]="collectionPublished"
        [collectionOwner]="collectionOwner"
        (downloadClick)="onDownloadClick()"
        (publishCollection)="publishCollection()"
        (unpublishCollection)="unpublishCollection(collectionId)"
        (shareCollection)="shareCollection()"
        (clearSearch)="clearSearch($event)"
        (applyFilters)="applyFilters($event)"
        (deleteCollection)="deleteCollection()"
        (addToDashboard)="addToDashboard()"
        (restFormField)="restFormField()"
        [searchText]="searchText"
        (searchTextChanged)="searchTextChanged($event)"
        [formResetter]="formResetter.asObservable()"
        (updateFormData)="updateFormData($event)"
        (currentSize)="currentSize = $event"
        (sortBy)="sortCollection($event)"
        (addOnEnter)="addOnEnter()"
        (toggleMobileSearch)="toggleMobileSearch()"
        (viewAssetTags)="viewAssetTags()"
      >
      </thehubz-asset-view-actions>
    </div>
    <div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }" (window:resize)="onEvent($event)" (focusout)="onEvent($event)" tabindex="0">
      <sp-search-field
        [searchText]="searchText"
        [maxWidth]="''"
        (keyUpInput)="searchTextChanged($event)"
        (clearInput)="clearSearch($event)"
        [placeholder]="searchPlaceholder"
        [mobileSearch]="true"
      ></sp-search-field>
    </div>
  </div>
  <div class="app-content-container w-full">
    <router-outlet (activate)="onRouteActivate($event)"></router-outlet>
  </div>
</div>
